export default __webpack_public_path__ + "static/media/photo_package_bg.182b88f6.jpg";